import React from "react";
import { Link, useLocation } from "react-router-dom";
import { BsChevronRight, BsHouseDoor } from "react-icons/bs";
import "../../styles/breadcrumb.css";

function Breadcrumb({ customItems }) {
  const location = useLocation();
  
  // If custom items are provided, use them
  if (customItems) {
    return (
      <nav className="breadcrumb-nav" aria-label="Breadcrumb">
        <ol className="breadcrumb-list">
          {customItems.map((item, index) => (
            <li key={index} className="breadcrumb-item">
              {index > 0 && <BsChevronRight className="breadcrumb-separator" />}
              {item.link ? (
                <Link to={item.link} className="breadcrumb-link">
                  {item.icon && <span className="breadcrumb-icon">{item.icon}</span>}
                  {item.label}
                </Link>
              ) : (
                <span className="breadcrumb-current">
                  {item.icon && <span className="breadcrumb-icon">{item.icon}</span>}
                  {item.label}
                </span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    );
  }

  // Auto-generate breadcrumbs from path
  const pathnames = location.pathname.split('/').filter(x => x);
  
  // Don't show breadcrumbs on home page
  if (pathnames.length === 0) {
    return null;
  }

  const breadcrumbItems = [
    { label: 'Home', link: '/', icon: <BsHouseDoor /> }
  ];

  pathnames.forEach((value, index) => {
    const to = `/${pathnames.slice(0, index + 1).join('/')}`;
    const isLast = index === pathnames.length - 1;
    
    // Format the label (capitalize and replace hyphens)
    const label = value
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');

    breadcrumbItems.push({
      label: label,
      link: isLast ? null : to
    });
  });

  return (
    <nav className="breadcrumb-nav" aria-label="Breadcrumb">
      <ol className="breadcrumb-list">
        {breadcrumbItems.map((item, index) => (
          <li key={index} className="breadcrumb-item">
            {index > 0 && <BsChevronRight className="breadcrumb-separator" />}
            {item.link ? (
              <Link to={item.link} className="breadcrumb-link">
                {item.icon && <span className="breadcrumb-icon">{item.icon}</span>}
                {item.label}
              </Link>
            ) : (
              <span className="breadcrumb-current">
                {item.icon && <span className="breadcrumb-icon">{item.icon}</span>}
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}

export default Breadcrumb;